import { SUBMIT_COVID_CHECKIN } from '@dtx-company/flow-codegen/src/page/mutations'
import {
  SubmitCovidCheckinMutation,
  SubmitCovidCheckinMutationVariables
} from '@dtx-company/flow-codegen/src/page/generated.types'
import { pageGqlFetcher } from '@dtx-company/inter-app/src/services/gqlFetcher'

const checkInMutation = async (
  input: SubmitCovidCheckinMutationVariables['CovidCheckinInput']
): Promise<void> => {
  await pageGqlFetcher<SubmitCovidCheckinMutation, SubmitCovidCheckinMutationVariables>(
    SUBMIT_COVID_CHECKIN,
    {
      CovidCheckinInput: input
    }
  )
}

export default checkInMutation
